export const painPoints = [
  {
    icon: 'pause',
    title: 'El miedo te paraliza',
    text: 'Sabes lo que quieres, pero algo dentro te frena justo antes de dar el paso.',
  },
  {
    icon: 'clock',
    title: 'Postergas decisiones',
    text: 'Esa conversación, ese cambio, ese proyecto. Siempre "más adelante".',
  },
  {
    icon: 'compass',
    title: 'Te faltan herramientas',
    text: 'Has leído mucho, pero nadie te enseñó qué hacer con el miedo cuando aparece.',
  },
  {
    icon: 'split',
    title: 'Lo emocional y lo espiritual van por separado',
    text: 'La terapia por un lado, tu fe o tu práctica por otro. Nunca terminan de unirse.',
  },
] as const

export const benefits = [
  {
    icon: 'eye',
    title: 'Reconoces tu miedo',
    text: 'Le pones nombre a lo que sientes y dejas de vivirlo como algo difuso.',
  },
  {
    icon: 'wind',
    title: 'Recuperas la calma',
    text: 'Prácticas simples para volver a tu cuerpo cuando la ansiedad aparece.',
  },
  {
    icon: 'sun',
    title: 'Decides con claridad',
    text: 'Eliges desde tu deseo, no desde la urgencia de evitar el dolor.',
  },
  {
    icon: 'heart',
    title: 'Te reconcilias contigo',
    text: 'El miedo deja de ser tu enemigo y empieza a ser un mensajero.',
  },
] as const

export const included = [
  'Mapa para identificar tus miedos reales (y los heredados)',
  'Herramientas psicológicas explicadas en lenguaje sencillo',
  'Prácticas espirituales para sostenerte en los días difíciles',
  'Plan diario de 21 días, corto y realista',
  'Hoja de trabajo descargable para escribir tu proceso',
  'Ejercicios de cierre para integrar lo aprendido',
] as const

export const coverImage =
  'https://cdn.magicpatterns.com/uploads/oUrYiapy52EYH1tvLAoiUm/portada_del_miedo_a_la_libertad.jpg'

export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/a7f96c97-b92b-4ff2-a22c-b82b3bffc9b4.jpg'

export const natureImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/82459a89-24b0-45bc-86ca-7fcf8775ca1a.jpg'
